import React from 'react';
import GoogleChatIcon from './GoogleChatIcon';

/** 참고 이미지 톤: 플랫 단색 블루 + 화이트 디테일 */
const BLUE = '#2196F3';
const WHITE = '#FFFFFF';

function FlatIcon({ size = 44, children }) {
  return (
    <svg
      viewBox="0 0 48 48"
      width={size}
      height={size}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      {children}
    </svg>
  );
}

function IconGlyph({ cardId }) {
  switch (cardId) {
    case 'google-chat':
      return <GoogleChatIcon size={44} />;

    case 'attendance':
      return (
        <FlatIcon>
          <circle cx="24" cy="26" r="14" fill={BLUE} />
          <circle cx="24" cy="26" r="10" fill={WHITE} />
          <path d="M24 20v7l5 3" stroke={BLUE} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
          <rect x="22" y="8" width="4" height="5" rx="1" fill={BLUE} />
        </FlatIcon>
      );

    case 'vehicle-operation':
      return (
        <FlatIcon>
          <rect x="11" y="24" width="26" height="12" rx="3.5" fill={BLUE} />
          <path fill={BLUE} d="M15 24c0-4.5 3.5-8 9-8s9 3.5 9 8H15z" />
          <rect x="18" y="18" width="12" height="7" rx="2" fill={WHITE} />
          <rect x="20" y="20" width="3.5" height="3" rx="0.7" fill={BLUE} />
          <rect x="24.5" y="20" width="3.5" height="3" rx="0.7" fill={BLUE} />
          <circle cx="16" cy="36" r="3.2" fill={BLUE} />
          <circle cx="16" cy="36" r="1.4" fill={WHITE} />
          <circle cx="32" cy="36" r="3.2" fill={BLUE} />
          <circle cx="32" cy="36" r="1.4" fill={WHITE} />
          <rect x="8" y="38" width="32" height="2" rx="1" fill={BLUE} opacity={0.35} />
        </FlatIcon>
      );

    case 'internal-training':
      return (
        <FlatIcon>
          <path fill={BLUE} d="M10 14l14-6 14 6v18l-14 6-14-6V14z" />
          <rect x="18" y="22" width="12" height="10" rx="1.5" fill={WHITE} />
          <rect x="20" y="25" width="8" height="2" rx="1" fill={BLUE} />
          <rect x="20" y="29" width="5" height="2" rx="1" fill={BLUE} />
        </FlatIcon>
      );

    case 'schedule':
      return (
        <FlatIcon>
          <rect x="9" y="13" width="26" height="24" rx="2.5" fill={BLUE} />
          <rect x="15" y="8" width="4" height="7" rx="1.2" fill={BLUE} />
          <rect x="29" y="8" width="4" height="7" rx="1.2" fill={BLUE} />
          <rect x="13" y="18" width="5.5" height="4.5" rx="0.8" fill={WHITE} />
          <rect x="21" y="18" width="5.5" height="4.5" rx="0.8" fill={WHITE} />
          <rect x="29" y="18" width="5.5" height="4.5" rx="0.8" fill={WHITE} />
          <rect x="13" y="25" width="5.5" height="4.5" rx="0.8" fill={WHITE} />
          <rect x="21" y="25" width="5.5" height="4.5" rx="0.8" fill={WHITE} />
          <rect x="29" y="25" width="5.5" height="4.5" rx="0.8" fill={WHITE} />
          <circle cx="34" cy="34" r="11" fill={BLUE} />
          <path d="M34 28v6h6" stroke={WHITE} strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round" fill="none" />
        </FlatIcon>
      );

    case 'erp':
      return (
        <FlatIcon>
          <path fill={BLUE} d="M10 38V18l14-7 14 7v20H10z" />
          <rect x="18" y="28" width="12" height="10" fill={WHITE} />
          <rect x="20" y="20" width="8" height="3" rx="1" fill={WHITE} />
          <rect x="20" y="31" width="8" height="2" rx="0.5" fill={BLUE} />
        </FlatIcon>
      );

    case 'receipt':
      return (
        <FlatIcon>
          <path
            fill={BLUE}
            d="M14 8h20v32l-3.5-2.5L27.5 40 24 37.5 20.5 40 17 37.5 14 40V8z"
          />
          <rect x="18" y="14" width="12" height="2" rx="1" fill={WHITE} />
          <rect x="18" y="19" width="12" height="2" rx="1" fill={WHITE} />
          <rect x="18" y="24" width="8" height="2" rx="1" fill={WHITE} />
          <circle cx="30" cy="30" r="5" fill={WHITE} />
          <path d="M28 30l1.5 1.5L32 27" stroke={BLUE} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" fill="none" />
        </FlatIcon>
      );

    case 'my-salary-leave':
      return (
        <FlatIcon>
          <rect x="8" y="14" width="32" height="22" rx="3" fill={BLUE} />
          <rect x="12" y="18" width="24" height="14" rx="2" fill={WHITE} />
          <rect x="15" y="22" width="10" height="2" rx="1" fill={BLUE} />
          <rect x="15" y="27" width="16" height="2" rx="1" fill={BLUE} />
          <circle cx="32" cy="27" r="3" fill={BLUE} />
        </FlatIcon>
      );

    case 'user-admin':
      return (
        <FlatIcon>
          <circle cx="18" cy="17" r="7" fill={BLUE} />
          <circle cx="18" cy="17" r="4" fill={WHITE} />
          <path fill={BLUE} d="M8 38c1.5-6 5-9 10-9s8.5 3 10 9H8z" />
          <rect x="30" y="14" width="10" height="2.5" rx="1.2" fill={BLUE} />
          <rect x="33.5" y="11" width="2.5" height="8" rx="1.2" fill={BLUE} />
        </FlatIcon>
      );

    case 'feature-permissions':
      return (
        <FlatIcon>
          <path fill={BLUE} d="M24 6l14 6v10c0 8.5-6 14.5-14 16-8-1.5-14-7.5-14-16V12l14-6z" />
          <circle cx="24" cy="22" r="6" fill={WHITE} />
          <rect x="22" y="20" width="4" height="6" rx="1" fill={BLUE} />
          <circle cx="24" cy="19" r="2" fill={BLUE} />
        </FlatIcon>
      );

    case 'allowed-groups':
      return (
        <FlatIcon>
          <rect x="12" y="22" width="24" height="16" rx="3" fill={BLUE} />
          <path
            fill={BLUE}
            d="M18 22v-4a6 6 0 0 1 12 0v4"
          />
          <circle cx="24" cy="30" r="3" fill={WHITE} />
          <rect x="22.5" y="30" width="3" height="4" rx="1" fill={BLUE} />
        </FlatIcon>
      );

    case 'notifications':
      return (
        <FlatIcon>
          <path fill={BLUE} d="M8 27 27 13v26L8 27z" />
          <rect x="27" y="21" width="9" height="10" rx="2" fill={BLUE} />
          <rect x="30" y="24" width="3" height="4" rx="1" fill={WHITE} />
          <path
            d="M37 17c2.8 2 4.5 5.2 4.5 9"
            stroke={BLUE}
            strokeWidth="2.6"
            strokeLinecap="round"
            fill="none"
          />
          <path
            d="M41 13c4 2.8 6.5 7 6.5 13"
            stroke={BLUE}
            strokeWidth="2.6"
            strokeLinecap="round"
            fill="none"
          />
        </FlatIcon>
      );

    case 'my-notifications':
      return (
        <FlatIcon>
          <path fill={BLUE} d="M12 18a12 12 0 0 1 24 0v8l4 5H8l4-5v-8z" />
          <rect x="20" y="36" width="8" height="3" rx="1.5" fill={BLUE} />
          <circle cx="34" cy="14" r="5" fill={BLUE} />
          <circle cx="34" cy="14" r="2.2" fill={WHITE} />
        </FlatIcon>
      );

    case 'empty':
    default:
      return (
        <FlatIcon>
          <rect x="10" y="10" width="28" height="28" rx="3" fill={BLUE} />
          <rect x="15" y="18" width="18" height="2.5" rx="1" fill={WHITE} />
          <rect x="15" y="24" width="12" height="2.5" rx="1" fill={WHITE} />
          <rect x="15" y="30" width="8" height="2.5" rx="1" fill={WHITE} />
        </FlatIcon>
      );
  }
}

export default function DashboardCardIcon({ cardId, className = '' }) {
  return (
    <div className={`dashboard-card-icon ${className}`.trim()} aria-hidden>
      <IconGlyph cardId={cardId} />
    </div>
  );
}
